/** GENERATED by docs/marketing/tools/gen-ru-gemini.mjs (--kind i18n) from videoTitles.en.ts — never hand-written. */
export const videoTitles = {
  cbtHomeworkOverview:
    'Видео: как работают домашние задания в CopingCard — от назначения до готового результата',
};
